import { render, staticRenderFns } from "./SingleStoreInfo.vue?vue&type=template&id=68a6355c&"
import script from "./SingleStoreInfo.vue?vue&type=script&lang=js&"
export * from "./SingleStoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./SingleStoreInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports